import React from 'react';
import { useStyletron } from 'baseui';

import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';
import { ISubmitForm60 } from '../types';
import { FORM_LAYOUT_CONFIG, validationSchema, getFormConfig } from './formConfig';
import useSubmitForm60 from './useSubmitForm60';

const SubmitForm60 = (props: ISubmitForm60) => {
	const [css] = useStyletron();
	const { showLoader, setShowLoader, handleFormSubmit, handleFormCancel } = useSubmitForm60(props);
	const FORM_FIELD_CONFIG = getFormConfig();

	return (
		<div className={css({ width: '50vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				validationSchema={validationSchema}
				buttonLabels={{
					submitLabel: 'Submit',
					discardLabel: 'Cancel'
				}}
				hidePopUp
			/>
		</div>
	);
};

export default SubmitForm60;
